const COLORS = {
  blue: "#0D6EFD",
  primary: "#030213",
  bg: "#F9FAFB",
  light_gray: "#F3F4F6",
  gray_medium: "#717182",
  white: "#FFFFFF",
  light_blue: "#EFF6FF",
  text_muted: "#4A5565",
  border: "#E5E5E5",
};

export default COLORS;